import SignUp from './signUp';
export default SignUp;